import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import './Footer.css';

const symbols = [
  "AAPL", "GOOGL", "MSFT", "AMZN", "TSLA",
  "JPM", "UBS", "KO", "AXP", "MS",
  "LYG", "DIS", "BP", "QCOM", "BCS",
  "CSR", "CMCSK", "ERTS", "XLNX", "C"
];

// The AlphaVantage key now lives on the proxy, not in this bundle. A static
// site cannot keep a secret — see SECURITY.md — so the call goes through
// server/ instead, which holds the key and caches to protect the quota.
const API_URL = process.env.REACT_APP_API_URL;

function Footer() {
  const [stockData, setStockData] = useState({});
  const [error, setError] = useState(null); // Error state
  
  // Array of quant quotes
  const quantQuotes = [
    "Risk comes from not knowing what you're doing. - Warren Buffett",
    "The four most dangerous words in investing are: 'This time it's different.' - Warren Buffett",
    "The market is a device for transferring money from the impatient to the patient.",
    "Time is your friend; impulse is your enemy. - John Bogle",
    "I'm not made of airports! - Mr. Burns",
    "We can't afford to shop at any store that has a philosophy - Marge Simpson",
    "Price is what you pay. Value is what you get. - Warren Buffet",
    "Math is the only place where people buy 60 watermelons and nobody wonders why.",
    "“In God we trust. All others must bring data.” – W. Edwards Deming",
    "“Who needs a crystal ball when you have stochastic models?”",
    "“I run on coffee, code, and confidence intervals.”",
    "“My favorite machine-learning model is the one that works (at least 60% of the time).”",
    "“I don’t always hedge my bets, but when I do, I prefer to model them first.”",
    "“If I had a dollar for every time I debugged code, I’d already have my own hedge fund.”",
    "“I don’t make mistakes, I just develop interesting outliers.”",
    "“My relationship with volatility is complicated, but at least it’s not random.”",
    "“There are 10 kinds of people in the world: those who understand binary and those who don’t.”",
    "“I’m not overthinking, I’m just calculating the risk-reward ratio.”",


  ];


  useEffect(() => {
    const fetchRandomStock = async () => {
      try {
        if (!API_URL) {
          // No proxy configured (e.g. a local build without .env.local) —
          // stay quiet rather than showing an error for a decorative widget.
          return;
        }

        const randomSymbol = symbols[Math.floor(Math.random() * symbols.length)];
        const response = await axios.get(`${API_URL}/api/quote`, {
          params: { symbol: randomSymbol },
        });

        const { symbol, price, changePercent } = response.data;

        if (price) {
          const trendArrow = changePercent?.startsWith("-") ? "⬇️" : "⬆️";
          setStockData({ symbol, price, trendArrow });
          setError(null);
        } else {
          setError("Stock quote data is unavailable.");
        }
      } catch (error) {
        if (error.response) {
          // The proxy answered, but not with a quote.
          setError("Stock data is temporarily unavailable. Please try again later.");
        } else if (error.request) {
          // The request was made but no response was received
          setError("No response received from the API. Please check your internet connection.");
        } else {
          // Something happened in setting up the request that triggered an Error
          setError("Error setting up the request: " + error.message);
        }
      }
    };
    

    fetchRandomStock();
  }, []);

  const year = new Date().getFullYear();
  const randomQuote = quantQuotes[Math.floor(Math.random() * quantQuotes.length)];

  return (
    <Container fluid className="footer">
      <Row>
        
        <Col md="4" className="footer-stock-ticker" style={{ display: 'flex', alignItems: 'center' }}>
          {error ? (
            <p style={{ color: "red" }}> </p>
          ) : stockData.symbol ? (
            <h4 style={{ color: "#03dac6" }}>
              {stockData.symbol}: ${stockData.price} {stockData.trendArrow}
            </h4>
          ) : (
            <p>Loading stock price...</p>
          )}
        </Col>
        <Col md="4" className="footer-social-media" style={{ display: 'flex', alignItems: 'center' }}>
          <p style={{ marginLeft: '10px', color: "#03dac6" }}>"{randomQuote}"</p>
        </Col>
      </Row>
      <Col md="4" className="footer-copywright">
          <h3>© {year} Jide Oyelayo. All rights reserved.</h3>
        </Col>
    </Container>
  );
}

export default Footer;
